document.addEventListener("DOMContentLoaded", (event) => {
  const recommended_section = document.querySelector('.recommended-products-wrapper');

  if (recommended_section) {
    const options = {
      rootMargin: '400px'
    }

        console.log('url', recommended_section.dataset.url);

        const url = recommended_section.dataset.url;
          fetch(url)
          .then(response => {
            if (!response.ok) {
              console.error("response was not ok");
              return null;
            }
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              recommended_section.innerHTML = recommendations.innerHTML;
              const swiper_recommended = new Swiper('.recommendations-slider', {
                direction: 'horizontal',
                slidesPerView: 1.15,
                spaceBetween: 25,
                loading: 'lazy',

                navigation: {
                  nextEl: '.recommended-products-wrapper .swiper-button-next',
                  prevEl: '.recommended-products-wrapper .swiper-button-prev',
                },

                breakpoints: {
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                  1600: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                  },
                },
              });
            }

          })
          .catch(error => {
            console.error(error);
          });
        }

});